import React from 'react';
import { burnInFeaturedNavItems, burnInNavItems } from './BurnInAnalyticsPages';
import { artavaBrand } from '../../branding/artavaBrand';

export default function BurnInDashboardSidebar({ isOpen, onToggleSidebar, onNavigate, onLogout, styles, t }) {
  const featuredItemsByPath = new Map(burnInFeaturedNavItems.map((item) => [item.path, item]));
  const orderedFeaturedItems = [
    featuredItemsByPath.get('/burn-in-uut-status-summary'),
    featuredItemsByPath.get('/burn-in-pie-chart'),
    featuredItemsByPath.get('/burn-in-pareto-chart'),
    featuredItemsByPath.get('/burn-in-control-chart'),
    featuredItemsByPath.get('/burn-in-root-cause-analyzer'),
  ].filter(Boolean);
  const remainingNavItems = burnInNavItems.filter((item) => item.path !== '/burn-in-uut-status-summary');

  return (
    <div className={`${styles.dashboardSidebar} ${isOpen ? '' : styles.closed}`}>
      <div className={styles.sidebarMenu}>
        <a
          href={artavaBrand.websiteUrl}
          target="_blank"
          rel="noreferrer"
          className={styles.sidebarBrandingLink}
        >
          <img
            src={artavaBrand.logoSrc}
            alt={artavaBrand.companyName}
            className={styles.sidebarBrandingLogo}
          />
          <div className={styles.sidebarBrandingText}>
            <span>{t('Built By Artava Systems')}</span>
            <strong>{artavaBrand.websiteHost}</strong>
          </div>
        </a>
        <button
          type="button"
          onClick={onToggleSidebar}
          className={styles.sidebarToggle}
          aria-label={isOpen ? t('Hide sidebar') : t('Show sidebar')}
        >
          {isOpen ? t('Hide sidebar') : t('Show sidebar')}
        </button>
        <button onClick={() => onNavigate('/burn-in-dashboard')} className={`${styles.menuItem} ${styles.burnInMenuItem}`}>
          {t('Burn-In Dashboard')}
        </button>
        <button onClick={() => onNavigate('/dashboard')} className={styles.menuItem}>
          {t('Choose Dashboard')}
        </button>
        <button onClick={() => onNavigate('/burn-in-upload')} className={`${styles.menuItem} ${styles.burnInMenuItem}`}>
          {t('Upload Burn-In Files')}
        </button>
        <button onClick={() => onNavigate('/burn-in-files')} className={`${styles.menuItem} ${styles.burnInMenuItem}`}>
          {t('View Burn-In Files')}
        </button>
        {orderedFeaturedItems.map((item) => (
          <button
            key={item.path}
            onClick={() => onNavigate(item.path)}
            className={`${styles.menuItem} ${styles.burnInMenuItem}`}
          >
            {item.path === '/burn-in-root-cause-analyzer' ? 'Failure Link' : t(item.label)}
          </button>
        ))}
        {remainingNavItems.map((item) => (
          <button
            key={item.path}
            onClick={() => onNavigate(item.path)}
            className={`${styles.menuItem} ${styles.burnInMenuItem}`}
          >
            {t(item.label)}
          </button>
        ))}
        <button onClick={onLogout} className={styles.logoutButton}>
          {t('Logout')}
        </button>
      </div>
    </div>
  );
}
